module.exports = __webpack_public_path__ + "static/media/dinersClub.72d9efdc.svg";